import { jwtDecode } from "jwt-decode";

// This identifies a cache owner only; the server still validates authentication.
// Malformed tokens stay outside authenticated caches. Never include credentials.
export function authenticationCacheScope(token: string | undefined): string | null {
  if (!token) return null;
  try {
    const { sub, iss } = jwtDecode(token);
    if (sub) return JSON.stringify([iss ?? null, sub]);
  } catch {
    // Let the API reject malformed credentials instead of sharing another cache.
  }
  return "invalid-token";
}
